import React, {useMemo} from 'react';
import VStack from "../../../../../common/Layout/VStack";
import {t} from "../../../../../../services/i18n";
import FormInput from "../../../../../common/FormInput";
import {checkRequired} from "../../../../../../services/stepperService";
import MessageTextFormInput from "../../../../../common/MessageTextFormInput";

const UserNoteExport = (props) => {
    const { values, touched, errors, setFieldValue, validationObject, tags } = props;
    const charCount = useMemo(() => values.message_content?.length || 0, [values?.message_content]);

    const onTagClick = (label) => {
        if (`${values.message_content || ''} [${label}]`.length <= 320) {
            setFieldValue('message_content', `${values.message_content || ''}[${label}]`)
        }
        document?.getElementById('text-area-message')?.focus()
    }

    return (
        <VStack space={'0.8rem'}>
            <FormInput
                label={t('send-note-to-email')+checkRequired('email_to', validationObject)}
                value={values.email_to}
                name={'email'}
                onChangeCallback={val => setFieldValue('email_to', val)}
                error={(touched.email_to && errors.email_to) ? errors.email_to : null}
                width={'100%'}
                type='email'
                infoTooltip={t('export-note-email-tooltip')}
                placeholder={t('email-export-note-placeholder')}
            />
            <FormInput
                label={t('subject')+checkRequired('subject', validationObject)}
                value={values.subject}
                onChangeCallback={(val) => setFieldValue('subject', val)}
                error={(touched.subject && errors.subject) || null}
                width={'100%'}
                maxLength={40}
                showCount
                containerProps={{ mb: '24px' }}
                placeholder={t(`subject-email`)}
            />
            <MessageTextFormInput {...{tags, onTagClick, setFieldValue, values, maxLength: 320,
                touched, errors, name: 'message_content', placeholder: t('user-note-export-content-placeholder'), id: 'text-area-message',
                isSms: false, charCount, maxCharCount: 320, validationObject, helperAdditionalText: t('user-note-export-content-helper')}}/>
        </VStack>
    );
};

export default UserNoteExport;